module.exports = __webpack_public_path__ + "static/img/02.9e979d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/inno/02.jpg
// module id = 397
// module chunks = 1